<template>
    <div>Pivot</div>
</template>

<script>
/* eslint-disable */
import store from "../../store/index";
import axios from 'axios';
import WebDataRocks from "webdatarocks";
import "webdatarocks/webdatarocks.toolbar.min.js";
import "webdatarocks/webdatarocks.js";
export default {
  name: "Pivot",
  props: {
    afterchartdraw: Function,
    aftergriddraw: Function,
    beforegriddraw: Function,
    beforetoolbarcreated: Function,
    cellclick: Function,
    celldoubleclick: Function,
    componentFolder: String,
    customizeCell: Function,
    customizeContextMenu: Function,
    datachanged: Function,
    dataerror: Function,
    datafilecancelled: Function,
    dataloaded: Function,
    fieldslistclose: Function,
    fieldslistopen: Function,
    filterclose: Function,
    filteropen: Function,
    fullscreen: Function,
    global: Object,
    height: [String, Number],
    loadingdata: Function,
    loadinglocalization: Function,
    loadingolapstructure: Function,
    loadingreportfile: Function,
    localizationerror: Function,
    localizationloaded: Function,
    olapstructureerror: Function,
    olapstructureloaded: Function,
    openingreportfile: Function,
    querycomplete: Function,
    queryerror: Function,
    ready: Function,
    report: [String, Object],
    reportchange: Function,
    reportcomplete: Function,
    reportfilecancelled: Function,
    reportfileerror: Function,
    reportfileloaded: Function,
    runningquery: Function,
    toolbar: Boolean,
    update: Function,
    width: [Number, String]
  },
      data() {
    return {
      baseapi: process.env.VUE_APP_Service_URL,
      reportdata: []
    }
      },
  mounted: function() {
    window.addEventListener("studyIdChanged", (event) => {
      this.reportfun();
    });
     this.reportfun();
    this.webdatarocks = new WebDataRocks({
      ...this.$props,
      container: this.$el,
      beforetoolbarcreated: this.customizeToolbar,
      report: {}
    });
  },
  beforeUpdate() {
    return false;
  },
  methods: {
    async reportfun(){
      const idtoken = store.getters.getIdToken;
      const currentstudy = store.getters.getStudyIs;
      await axios
          .get(`${this.baseapi}/report/schedule/shedules?StudyId=${currentstudy}`,
              {
                  headers: {
                      Authorization: "Bearer " + idtoken,
                      "Content-Type": "application/json",

                  },
              }
          )
          .then((res) => {
              let resultarray = [{
    "studyName": {
type: "string"
},
    "languageCode": {
type: "string"
},
    "siteCode": {
type: "string"
},
    "patientNo": {
type: "string"
},

    "visitNo": {
type: "string"
},
    "visitName": {
type: "string"
},
    "templateName": {
type: "string"
},
    "templateId": {
type: "string"
},
    "visitDate": {
type: "string"
},
    "preVisit": {
type: "string"
},
    "postVisit": {
type: "string"
},
    "visitStatus": {
type: "string"
},
    "investigatorName": {
type: "string"
},
    "visitCompletedDate": {
type: "string"
},
    "active": {
type: "string"
},
    "version": {
type: "string"
},
  }, ...res.data];
              // this.webdatarocks.updateData({data:res.data
              // });
              let setrept = {
        dataSource: {
        data: resultarray
        },
        "options": {
        "grid": {
            "type": "flat",
            "showGrandTotals": "off"
        }
    },
      "formats": [
        {
           "textAlign":"left",
           "thousandsSeparator": "",
        }
    ],
        "slice": {
                    "rows": [
            {
                "uniqueName": "siteCode",
                "caption":"Site Code"
            },
            {
                "uniqueName": "patientNo",
                "caption":"Patient No."
            },
            {
                "uniqueName": "visitNo",
                "caption":"Visit No."
            },
            {
                "uniqueName": "visitName",
                "caption":"Visit Name"
            },
             {
                "uniqueName": "visitStatus",
                "caption":"Visit Status"
            },
             {
                "uniqueName": "investigatorName",
                "caption":"Investigator"
            }
        ],
      


    },
      }
      this.webdatarocks.setReport(setrept);
          });
    },
    customizeToolbar(toolbar) {
        var tabs = toolbar.getTabs(); // get all tabs from the toolbar
        toolbar.getTabs = function () {
           delete tabs[0]
           delete tabs[1] 
        // delete tabs[2]; // delete the second tab
            return tabs;
        }

    }
  }
};
</script>
<style scoped>
@import '~webdatarocks/webdatarocks.min.css';
</style>